import regularAppService from "./regularAppService";

export const getExpensesPage = async ({
  page,
  limit,
  search,
  sortBy = "updatedAt",
  sortOrder = "desc",
  filter,
} = {}) => {
  const isValidSearch = typeof search === "string" && search.trim().length > 0;
  const result = await regularAppService.getPaginated({
    collection: "expenses",
    ...(Number.isFinite(Number(page)) ? { page: Number(page) } : {}),
    ...(Number.isFinite(Number(limit)) ? { limit: Number(limit) } : {}),
    ...(isValidSearch ? { search } : {}),
    sortBy,
    sortOrder,
    ...(filter && typeof filter === "object" ? { filter } : {}),
  });
  return result;
};

export const getExpenses = async () => {
  const page = await regularAppService.getPaginated({ collection: "expenses" });
  return Array.isArray(page.items) ? page.items : [];
};

export const createExpense = async (expenseData) => {
  const newExpense = {
    ...expenseData,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  };
  const result = await regularAppService.upsert({
    collection: "expenses",
    data: newExpense,
  });
  return result;
};

export const updateExpense = async (expenseData) => {
  const updatedExpense = {
    ...expenseData,
    updatedAt: new Date().toISOString(),
  };

  const result = await regularAppService.upsert({
    collection: "expenses",
    data: updatedExpense,
  });
  return result;
};

export const deleteExpense = async (expenseId) => {
  const deletedExpense = {
    _id: expenseId,
    deleted: true,
    updatedAt: new Date().toISOString(),
  };

  const result = await regularAppService.upsert({
    collection: "expenses",
    data: deletedExpense,
  });
  return result;
};

export const searchExpenses = async ({ search = "" }) => {
  const isValid = typeof search === "string" && search.trim().length > 0;
  const pageResult = await regularAppService.getPaginated({
    collection: "expenses",
    ...(isValid ? { search } : {}),
  });
  return pageResult.items || [];
};

// Method to force a sync with the server
export const syncExpenses = async () => {
  return await getExpenses();
};

// Debugging function to reset and check expense data
export const debugExpenses = async () => {
  return [];
};
